const CORES_ANO = ["#1e5a8c", "#2a8f6f", "#c45c26", "#6b4c9a", "#b8860b"];

function anoDeCompetencia(competencia) {
  if (!competencia || competencia.length < 4) return null;
  const y = parseInt(competencia.slice(0, 4), 10);
  return Number.isFinite(y) ? y : null;
}

/**
 * Agrega métricas por ano civil a partir das linhas mensais filtradas.
 * @param {Array<object>} linhas
 * @param {'baseSelic'|'pis'|'cofins'} campo
 */
export function calcularDistribuicaoPorAno(linhas, campo) {
  const map = new Map();
  for (const linha of linhas || []) {
    const ano = anoDeCompetencia(linha.competencia);
    if (ano == null) continue;
    const valor = Number(linha[campo]) || 0;
    map.set(ano, (map.get(ano) || 0) + valor);
  }
  const itens = Array.from(map.entries())
    .map(([ano, valor]) => ({ ano, valor }))
    .sort((a, b) => a.ano - b.ano);
  const total = itens.reduce((s, i) => s + i.valor, 0);
  return itens.map((item, idx) => ({
    ...item,
    pct: total > 0 ? (item.valor / total) * 100 : 0,
    cor: CORES_ANO[idx % CORES_ANO.length],
  }));
}

export function formatarMoedaBRL(valor) {
  const n = Number(valor);
  if (!Number.isFinite(n)) return "R$ —";
  return `R$ ${n.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
